import React, { Component } from "react";

class Waiting extends Component {
  render() {
    const { t } = this.props;
    return (
      <div className="ui poly welcome background">
        <div className="ui poly welcome widget">
          <p>{t("Initializer.Welcome") !== "Initializer.Welcome" ? t("Initializer.Welcome") : ""}</p>
          <div className="ui poly welcome lockup">
            <div className="ui poly welcome spinner" />
            <div className="ui poly welcome logo" />
          </div>
        </div>
      </div>
    );
  }
}

export default Waiting;
